import React from 'react'
import AllOfficers from '../components/officers/AllOfficers'

const Officers = () => {
  return (
    <AllOfficers />
  )
}

export default Officers